import { Box, Container, Flex, Spacer, Stack, Text } from "@chakra-ui/react";
import AppFooter from "./Components/AppFooter";
import AppHeader from "./Components/AppHeader";

import MainRoute from "./Routes/MainRoute";

function App() {

  return (
	<>
		<Container p='0' shadow='2xl' maxW='md'>
			<Flex direction='column' height='100vh'>
				<AppHeader/>
				<MainRoute/>
				<Spacer/>
				<AppFooter/>
			</Flex>
		</Container>
		
	</>
  );
}

export default App;
